import { connect } from 'react-redux';

import geofences from 'APP_ROOT/data/geofences';

import Color from './Color';

const mapStateToProps = (state, ownProps) => {
    return {
        value: geofences.Selectors.geofenceColor(state, ownProps.geofenceId),
        status: geofences.Selectors.geofenceStyleChangePending(state, ownProps.geofenceId) ? 'PENDING' : '',
        colors: geofences.COLORS,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (color) => dispatch(
            geofences.Actions.setGeofenceStyle(ownProps.stage, ownProps.geofenceId, { 'fill-color': color })
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Color);
